import {
  Flex,
  Input,
  Form,
  Button,
  Card,
  theme,
  message,
  Typography,
} from 'antd';
import { Rule } from 'antd/es/form';
import { useContext, useEffect, useState } from 'react';
import { useClient } from '../client';
import { AxiosError, CanceledError } from 'axios';
import { AppContext } from '../context';
import { GoogleLogin } from '@react-oauth/google';
import { Link } from 'react-router-dom';

const emailRules: Rule[] = [
  { required: true, message: '${label} is required' },
  { type: 'email', message: 'Valid email is required' },
];

const passwordRules: Rule[] = [
  { required: true, message: '${label} is required' },
];

type PasswordCredentialsType = {
  email: string;
  password: string;
  type: 'password';
};
type GoogleCredentialsType = { token: string; type: 'google' };

export default function Auth() {
  const { token: themeToken } = theme.useToken();
  const [processing, setProcessing] = useState(false);
  const [credentials, setCredentials] = useState<
    PasswordCredentialsType | GoogleCredentialsType
  >();
  const [messageApi, contextHolder] = message.useMessage();
  const { setUser } = useContext(AppContext);
  const client = useClient(null);

  useEffect(() => {
    if (!processing || !credentials) return;
    (async () => {
      try {
        const user =
          credentials.type === 'google'
            ? await client.signUpGoogle(credentials.token)
            : await client.loginWithPassword(
                credentials.email,
                credentials.password
              );
        setUser(user);
      } catch (error) {
        if (error instanceof CanceledError) return;
        if (error instanceof AxiosError && error.status === 401) {
          messageApi.error('Incorrect credentials');
          console.log('Incorrect credentials:', error);
        } else {
          messageApi.error('Login error');
          console.log('Login error:', error);
        }
      }
      setProcessing(false);
    })();
  }, [processing, messageApi, credentials, setUser, client]);

  return (
    <Flex
      className="auth-container"
      justify="center"
      align="center"
      style={{ backgroundColor: themeToken.colorPrimary }}
    >
      {contextHolder}
      <div>
        <Card>
          <Form
            className="token-auth-form"
            onFinish={(newParams: Record<string, any>) => {
              setCredentials({
                ...newParams,
                type: 'password',
              } as PasswordCredentialsType);
              setProcessing(true);
            }}
          >
            <div>
              <Form.Item
                key={'param-email'}
                name="email"
                label="Email"
                rules={emailRules}
                required={false}
              >
                <Input autoComplete="email" />
              </Form.Item>
              <Form.Item
                key={'param-token'}
                name="password"
                label="Password"
                rules={passwordRules}
                required={false}
              >
                <Input.Password autoComplete="password" />
              </Form.Item>
            </div>
            <div className="login-signup-btns-container">
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={processing}>
                  Login
                </Button>
              </Form.Item>
              {/* TODO finalize auth */}
              {/* <Typography.Text>OR</Typography.Text>
              <Link to="sign-up">
                <Button>Sing Up</Button>
              </Link> */}
            </div>
          </Form>
        </Card>
        <Card className="google-login-card">
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              setCredentials({
                token: credentialResponse.credential || '',
                type: 'google',
              });
              setProcessing(true);
            }}
            onError={() => {
              console.log('Login Failed');
              messageApi.error('Login Failed');
            }}
          />
        </Card>
      </div>
    </Flex>
  );
}
